module.exports = __webpack_public_path__ + "assets/img/role-type-3.38954929.png";